import { Component, Input, ElementRef, Output, EventEmitter, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { BreadcrumbModel, BObjectModel, PropertyData, PropertyGroup, ModeBo } from '../../models';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-dynamic-tag-group',
  templateUrl: './dynamic-tag-group.component.html',
  styleUrls: ['./dynamic-tag-group.component.css']
})

export class DynamictagGroupComponent implements AfterViewInit {

  public model: BObjectModel;
  public breadcrump: BreadcrumbModel;
  public modeBoEnum =  ModeBo;
  public modeBo: ModeBo = ModeBo.Edit;
  @Input('ModeBo') set Mode(value: ModeBo) { this.modeBo = value; };
  @Input('Model') set Model(value: BObjectModel) { this.model = value; }
  @Input('item') item: PropertyData[];
  @Input('title') title: string;
  @Input('parent') parent: ElementRef;
  @Input('itemGrp') itemGrp: PropertyGroup;
  @Output() sendBreadcrumb: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>(true);

  constructor(
    private cd: ChangeDetectorRef
  ) { }


  ngAfterViewInit(): void {
    // in order to avoid the ExpressionChangedAfterItHasBeenCheckedError when we load "<ng-container [ngTemplateOutlet]="
    // due to the "change detection cycle" that Angular performs for each component in the application's tree of components
    // (NB - it happens only in development environment)
    // we injected in the class contructor the ChangeDetectorRef class
    // this force another "change detection cycle" for the parent dynamictag.component to detect chamges in children components loaded in the ng-container template
    this.cd.detectChanges();
  }


  // action associated to the label of each element
  public methodLabel(e: string): void { }

  public getBreadcrump(breadCrumb: BreadcrumbModel): void {
    this.sendBreadcrumb.emit(breadCrumb);
  }

  public IsVisible(item: PropertyData): boolean {
    return item.MainLabel.Visible && item.MainElementList && item.MainElementList.length > 0 && item.MainElementList[0].Mask !== 'DATEFIN';
    //return item.Mode === 'COMPLEX'
    //  ? item.MainLabel.Visible && item.MainElementList[0].Mask !== 'DATEFIN'
    //  : item.MainLabel.Visible;
  }
}
